import { useNavigate } from "react-router-dom";
import { NotificationPreview } from "../../components/NotificationPreview";

interface PushNotificationFormThankYouProps {
  formValues: any;
  reset: any;
  setShowThankYou: (value: boolean) => void;
  setCurrentStep: (step: number) => void;
}

const PushNotificationFormThankYou = ({
  formValues = {},
  reset,
  setShowThankYou,
  setCurrentStep,
}: PushNotificationFormThankYouProps) => {
  const navigate = useNavigate();

  const handleOnClickStatus = () => {
    navigate("/dashboard");
  };
  const handleOnClickComposeNew = () => {
    reset();
    setCurrentStep(1);
    setShowThankYou(false);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-1 flex-col gap-4 mt-8 items-center">
        <h1 className="text-[32px]">Thank you!</h1>
        <p className="text-neutral-800">
          This push notification now scheduled to be sent
        </p>
      </div>
      <div className="flex flex-1 flex-col mt-8 bg-white p-8 rounded-lg shadow-lg w-[90%] text-[14px] items-center">
        <div className="w-[500px]">
          <NotificationPreview
            body={formValues.body}
            title={formValues.title}
          />
        </div>
      </div>
      <div className="flex flex-1 flex-row gap-4 mt-8 w-[90%]">
        <button
          onClick={handleOnClickComposeNew}
          className="font-[ApercuProBold] text-[16px] flex flex-1 bg-white rounded-md shadow-lg p-4 items-center justify-center"
        >
          Compose a New Notification
        </button>
        <button
          onClick={handleOnClickStatus}
          className="flex flex-1 bg-black/75 text-white rounded-md shadow-lg p-4 items-center justify-center font-[ApercuProBold] text-[16px]"
        >
          Status
        </button>
      </div>
    </div>
  );
};

export default PushNotificationFormThankYou;
